export const UNREAD_COUNT_REQUESTED = 'io/conversations/UNREAD_COUNT_REQUESTED';
export const UNREAD_COUNT_RECEIVED = 'io/conversations/UNREAD_COUNT_RECEIVED';
export const READ_ONE = 'io/conversations/READ_ONE';
export const MESSAGE_MARKED_READ = 'io/conversations/MESSAGE_MARKED_READ';
